import { ChainName, EXPLORER } from 'src/common/static'

export const formatRate = (rate: number): string => `${(rate * 100).toFixed(2)}%`

export const etherscanTxUrl = (chain: ChainName | undefined, hash: string): string =>
  `${EXPLORER[chain ?? ChainName.ETHEREUM] ?? ''}/tx/${hash}`

// Column / metric tooltip copy (terminology per the product spec).
export const TOOLTIPS = {
  netRevenuePayout: 'Net QCAD Earned',
  effectiveRate: 'Net Rate (Annualized)',
  avgDailyBalance: 'Avg. Daily Balance (QCAD) / MTD',
  grossAccrual: 'Gross QCAD Earned',
  allowableExpenses: 'Allowable Expenses (QCAD)'
}

export const QCAD = 'QCAD'
